module.exports = __webpack_public_path__ + "static/media/Life Is Worth Living - Instrumental Version.0d290f06.jpg";